import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Repeat04 = function Repeat04(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M12 20.5001c4.6944 0 8.5-3.8056 8.5-8.5 0-2.8255-1.3787-5.329-3.5-6.8746m-4 17.2746-2-2 2-2m-1-14.9c-4.6944 0-8.5 3.8056-8.5 8.5 0 2.8255 1.3787 5.3291 3.5 6.8746m4-13.2746 2-2-2-2"
    })
  }));
};
export default Repeat04;